<script>
import {
  pointRetraitSelectorEmits,
  pointRetraitSelectorProps,
  usePointRetraitSelector
} from "./mixin";

import Map from "@/components/molecules/map";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ShippingServiceContainer from "@/containers/shipping-method/shipping-method-service";
import FormRadio from "@/components/molecules/form-radio";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Button from "@/components/atoms/button";
import Popin from "@/components/molecules/popin";

export default {
  name: "PointRetraitSelector",
  components: {
    Map,
    List,
    ListItem,
    ShippingServiceContainer,
    FormRadio,
    GridCol,
    GridRow,
    Button,
    Popin
  },
  props: {
    ...pointRetraitSelectorProps()
  },
  emits: [...pointRetraitSelectorEmits()],
  computed: {
    currentSelectedService() {
      if (this.selectedServiceId) {
        return this.services.find(
          (service) => service.id === this.selectedServiceId
        );
      }
      return null;
    }
  },
  data() {
    return {
      selectedServiceId: null,
      raisonsImpossible: null
    };
  },
  methods: {
    localize(service) {
      const position = this.getServicePosition(service);
      this.map.showMarkerByPosition(position);
    },
    showServiceAtPosition(position) {
      const service = this.getServiceFromPosition(position);
      if (service) {
        const domElem = document.getElementById(`point-${service.id}`);
        if (domElem) {
          this.$refs.list.$el.scrollTop = domElem.offsetTop;
        }
      }
    },
    isServiceDisabled(service) {
      return this.infosPossibleServices[service.id]
        ? this.infosPossibleServices[service.id].possible === false
        : true;
    },
    showRaisonsIndispo(service) {
      this.raisonsImpossible = this.infosPossibleServices[service.id].raisons;
      this.$refs.raisonsIndispo.show();
    }
  },
  setup(props, context) {
    const map = ref(null);
    const PointRetraitSelectorItem = defineAsyncComponent(() =>
      import("./point-retrait-selector-item/default")
    );
    const {
      positions,
      showMap,
      serviceSelected,
      serviceSelectedFromMap,
      getServiceFromPosition,
      getServicePosition
    } = usePointRetraitSelector(props, context);
    return {
      positions,
      showMap,
      serviceSelected,
      serviceSelectedFromMap,
      getServiceFromPosition,
      getServicePosition,
      PointRetraitSelectorItem,
      map
    };
  }
};
</script>

<template>
  <div>
    <div
      v-if="showMap"
      class="c-point-retrait-selector"
    >
      <div class="u-flex">
        <List
          ref="list"
          class="c-point-retrait-selector__col c-point-retrait-selector__list"
        >
          <ListItem
            v-for="service in services"
            :id="`point-${service.id}`"
            :key="`point-${service.id}`"
            class="c-point-retrait-selector__item"
          >
            <ShippingServiceContainer
              :service="service"
              :component="PointRetraitSelectorItem"
              class="c-point-retrait-selector__item-content"
              @click="serviceSelected(service)"
              @localize="localize(service)"
            />
          </ListItem>
        </List>
        <div class="c-point-retrait-selector__col">
          <Map
            ref="map"
            :positions="positions"
            class="c-point-retrait-selector__map"
            @positionClicked="serviceSelectedFromMap($event)"
            @positionSelected="showServiceAtPosition($event)"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <Popin
        ref="raisonsIndispo"
        aria-label="Raisons de l'indisponibilité"
      >
        <p
          v-for="(raison, index) in raisonsImpossible"
          :key="`raison-${raison.type_raison}-${index}`"
          class="u-font-14 u-mb-xs u-mt-xs"
        >
          {{ raison.raison }}
        </p>
      </Popin>
      <GridRow>
        <GridCol
          v-for="service in services"
          :key="`point-${service.id}`"
          cols="6"
        >
          <FormRadio
            v-model="selectedServiceId"
            name="address"
            block
            :value="service.id"
            class="u-mb-sm"
            :disabled="isServiceDisabled(service)"
          >
            <p>
              <strong>{{ service.description }}</strong> <br>
              {{ service.adresse }}
              <template v-if="service.details">
                <br>
                {{ service.details }}
              </template>
              <template v-if="isServiceDisabled(service)">
                <br>
                <br>
                <Button
                  link
                  @click="showRaisonsIndispo(service)"
                >
                  <span class="u-font-13 u-color-text">
                    Pourquoi est-il indisponible ?
                  </span>
                </Button>
              </template>
            </p>
          </FormRadio>
        </GridCol>
      </GridRow>
      <div class="u-text-center u-mt-md u-mb-lg">
        <Button
          variant="secondary"
          radius="full"
          size="md"
          :disabled="!selectedServiceId"
          @click="serviceSelected(currentSelectedService)"
        >
          Je valide ce point de retrait
        </Button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-point-retrait-selector {
  height: 400px;
  width: 100%;
  overflow: hidden;
  background: color(white);
  border-radius: radius(md);
  border: 1px solid color(grey-3);
}
.c-point-retrait-selector__map {
  height: 100%;
}
.c-point-retrait-selector__item {
  border-bottom: 2px dotted color(grey-4);
}

.c-point-retrait-selector__item-content {
  padding: spacing(sm);
}
.c-point-retrait-selector__col {
  flex-basis: 50%;
  flex-grow: 0;
}
.c-point-retrait-selector__list {
  overflow-y: auto;
  height: 400px;
  position: relative;
}
</style>
